<template>
  <div v-if="visible.length" class="fixed inset-0 z-[60] bg-black/40 overflow-y-auto p-4">
    <div class="min-h-full flex items-center justify-center">
      <div class="w-full max-w-3xl space-y-4">
        <div
          v-for="n in visible"
          :key="n.NoticeID"
          class="bg-white rounded-lg shadow-xl w-full max-h-[85vh] flex flex-col"
        >
          <div class="flex items-center justify-between px-5 py-3 border-b">
            <h3 class="font-bold text-lg truncate">{{ n.Title }}</h3>
            <button class="btn btn-sm btn-ghost btn-circle" @click="close(n)">✕</button>
          </div>
          <div class="px-5 pt-2 text-xs text-gray-400">{{ fmt(n.CreateDate) }}</div>
          <div class="px-5 py-3 overflow-y-auto text-sm leading-relaxed notice-content" v-html="n.Contents"></div>
          <div class="flex items-center justify-between px-5 py-3 border-t">
            <label class="flex items-center gap-1 text-sm text-gray-500 cursor-pointer">
              <input type="checkbox" class="checkbox checkbox-xs" v-model="dontToday[n.NoticeID]" /> 오늘 하루 보지 않기
            </label>
            <button class="btn btn-sm btn-primary" @click="close(n)">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from "vue";
import { lmsApi } from "../utils/api";
import { formatDate } from "../utils/format";

const visible = ref<any[]>([]);
const dontToday = reactive<Record<number, boolean>>({});
const fmt = (d: any) => formatDate(d);
const todayStr = new Date().toISOString().slice(0, 10);

function dismissedKey(id: number) { return `noticePopup:${id}:${todayStr}`; }

function close(n: any) {
  if (dontToday[n.NoticeID]) localStorage.setItem(dismissedKey(n.NoticeID), "1"); // 오늘 하루 보지 않기
  visible.value = visible.value.filter((x) => x.NoticeID !== n.NoticeID);
}

onMounted(async () => {
  if (!localStorage.getItem("token")) return;
  try {
    const res = await lmsApi.get<any>("/api/admin/notice-popup");
    // 백엔드는 배열(최대 3건) 반환. 과거 단건 응답도 방어.
    const list = Array.isArray(res) ? res : res ? [res] : [];
    visible.value = list.filter(
      (n) => n && n.NoticeID && localStorage.getItem(dismissedKey(n.NoticeID)) !== "1",
    );
  } catch (e) {
    console.error("공지 팝업 로드 실패:", e);
  }
});
</script>

<style scoped>
/* 에디터 HTML 내부 이미지가 넘치지 않도록 */
.notice-content :deep(img) { max-width: 100%; height: auto; }
</style>
